

import CryptoJS from "crypto-js";
import credit_card from "../../../components/shared/credit_card/credit_card.vue";

import { loadingOverlay } from "vuetify-more-component";
import suscripcionTabs  from "../suscripcion/gestor_suscripcion.vue";
import  menuGestor  from "../menu/menu.vue";


export default {
  components: { credit_card, loadingOverlay, suscripcionTabs, menuGestor },
  name: "Login",
  data() {
    return {
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      checkbox: false,

      departamentos: [],
      municipios: [],

      cargando_info: false,

      gestor: {
        departamento: null,
        municipio: null,
        direccion: "",
        nombre_oficina: "",
      },

      rules_campo_obligatorio: [
        (v) => !!v || "Campo obligatorio"
      ],

      usuario : {
        direccion: "",
      },

      suscripcion: null,

      menu_calendario: false,
      date: '',
      fecha_aux: '',
      mostrar: false,
    };
  },

  async created() {
    this.cargando_info = true;
    await this.getDeps();
    this.cargando_info = false;

  },

  mounted() {
    let informacion_incriptada = sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-todo');
    if (informacion_incriptada != null) {
      let key_pass = atob(sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-tic'))
      let bytes = CryptoJS.AES.decrypt(informacion_incriptada, key_pass + "byTeamT0d0T1c");
      let informacion_desincriptada = bytes.toString(CryptoJS.enc.Utf8);
      let r = JSON.parse(informacion_desincriptada)
      this.usuario = r.usuario[0]
      this.suscripcion = r.suscripcion
      console.log("usuario log", this.usuario);
    }
  },

  watch: {
    date(){
      this.gestor.fecha_establecimiento = this.date;
      this.fecha_aux = this.date.toString().split("-").reverse().join("/");
    }

  },

  computed: {
    size() {
      const size = { xs: "x-small", sm: 'medium', md: 'medium', lg: 'large', xl: 'large' }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {}
    }
  },

  methods: {
    validate () {
     const isValid = this.$refs.form.validate()
     if(!isValid) {
        this.$toast.warning("Por favor complete los campos obligatorios",
        {
          duration: 5000,
          position: "bottom-center",
          closeable: true,
        });
        return;
      }

     console.log(isValid);
     this.gestor.id = this.usuario.id;
     this.completeAddress();
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    async getDeps() {
      try {
        let r = await this.$store.state.services.registerService.departamentos();
        this.departamentos = r.data.data;
      } catch (error) {
        this.$toast.error("Ocurrió un error al obtener los departamentos");
      }
    },

    verMuni() {
      if (this.gestor.departamento !== null) {
        this.municipios = this.departamentos.filter(x => x.id === this.gestor.departamento.id)[0].municipio;
        return true;
      }
    },

    async completeAddress() {
      try {
        this.cargando_info = true;
        let r = await this.$store.state.services.gestoresService.completeAddress(this.gestor);
        if (r.data.success) {
          this.cargando_info = false;
          this.usuario.direccion = this.gestor.direccion;
          let clave_data = "dsgfv/&#$%sdksdn..sd5454sd-todo"
          sessionStorage.setItem(clave_data, CryptoJS.AES.encrypt(JSON.stringify(this.usuario), this.usuario.token + "byTeamT0d0T1c").toString());
          this.$toast.success("Dirección completada");

        }
      } catch (error) {
        this.$toast.error("Ocurrió un error al completar la dirección");
        this.cargando_info = false;        
      }
  }
  }
};